import './form-label.scss';
var FormLabel = /** @class */ /*@__PURE__*/ (function () {
    function FormLabel() {
    }
    return FormLabel;
}());
export { FormLabel };
